import { stringify } from 'query-string';
import Client from '~/types/api/api-module';
import { PhoneTypePayload } from '~/types/api/phone-type-payload';
import ApiOptions from '../api-options';

const DATA_PLAN_URL = `${process.env.API_V4_HOST}/phone-credits/prepaid-transactions`;
const DATA_PLAN_INQUIRY_URL = `${process.env.API_V4_HOST}/phone-credits/prepaid-products`;

export default Client.wrap({
  Private: {
    // Get phone credit prepaid products
    fetchDataPlanProducts(query: Record<string, string | number | undefined> = {}) {
      return this.get(`${DATA_PLAN_INQUIRY_URL}?${stringify(query)}`, 'user', new ApiOptions({}));
    },
    /** @deprecated **/
    postDataPlanTransaction(payload: PhoneTypePayload) {
      const { packageId, phoneNumber } = payload;
      const requestPayload = {
        package_id: packageId,
        phone_number: phoneNumber,
      };
      return this.post(DATA_PLAN_URL, 'user', new ApiOptions({ requestPayload }));
    },
    getDataPlanTransaction(id) {
      return this.get(`${DATA_PLAN_URL}/${id}`, 'user', new ApiOptions());
    },
  },
});
